// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1hlma","containerItemsCenter":"Skeleton_containerItemsCenter__3ajDl"};